// Copyright (C) 2012-present, The Authors. This program is free software: you can redistribute it and/or  modify it under the terms of the GNU Affero General Public License, version 3, as published by the Free Software Foundation. This program is distributed in the hope that it will be useful, but WITHOUT ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU Affero General Public License for more details. You should have received a copy of the GNU Affero General Public License along with this program.  If not, see <http://www.gnu.org/licenses/>.

const s = {}

s.share_but_no_comments_warning =
  "This conversation has no comments. We recommend you add a few comments before inviting participants. This will help participants get started. Go to 'Configure' and then 'Seed Comments'."
s.share_but_no_visible_comments_warning =
  'This conversation has no visible comments. We recommend you add a few comments (or moderate the comments that exist) before inviting participants, since this will help them understand what kind of comments they should submit.'

s.no_permission = 'Your account does not have the permissions to view this page.'

// Interstitial (CID analytics — already included)
s.polis2_heading = 'Advanced AI analytics — already included'
s.polis2_intro =
  'Your Polis instance by the Center for Innovations Development (CID) includes a full suite of analytics, demographics and AI reporting — free for communities.'
s.polis2_stats_heading = 'Opinion clusters & topics'
s.polis2_stats_text =
  'Opinion groups, representative statements, consensus zones and an interactive topic map — see where the community agrees and where it diverges.'
s.polis2_ai_heading = 'Demographics, UTM & AI reports'
s.polis2_ai_text =
  'Participant entry profile (gender, age, status), acquisition-channel analytics (UTM) and narrative AI reports in Word — with explanations and charts.'
s.polis2_features_heading = "What's included:"
s.polis2_feature_summaries = 'Narrative AI reports (Word / docx)'
s.polis2_feature_topics = 'Topic map & opinion clusters'
s.polis2_feature_consensus = 'Participant demographic profile'
s.polis2_feature_divisive = 'UTM acquisition-channel analytics'
s.polis2_cta = 'Learn more about the platform:'
s.polis2_upgrade = 'polis.cid.center'
s.btn_maybe_later = 'Skip'
s.btn_create_conversation = 'Create conversation'

// Create-conversation demographic choice
s.create_demographics_label = 'Enable a participant demographic survey'
s.create_demographics_hint =
  'A short entry survey (gender, age, social status, work situation) shown before voting. You can change this later in Configure.'

// Conversation config (settings) page
s.cfg_configure = 'Configure'
s.cfg_saving = 'Saving'
s.cfg_uptodate = 'Up to date'
s.cfg_error_saving = 'Error Saving'
s.cfg_topic = 'Topic'
s.cfg_description = 'Description'
s.cfg_seed_comments = 'Seed Comments'
s.cfg_customize_ui = 'Customize the user interface'
s.cfg_is_active_desc =
  'Conversation is open. Unchecking disables both voting and commenting.'
s.cfg_vis_desc = 'Participants can see the visualization'
s.cfg_write_desc = 'Participants can submit comments'
s.cfg_help_desc = 'Show explanation text above voting and visualization'
s.cfg_subscribe_desc =
  'Prompt participants to subscribe to updates. A prompt is shown to users once they finish voting on all available comments. If enabled, participants may optionally provide their email address to receive notifications when there are new comments to vote on.'
s.cfg_strict_mod_desc = 'No comments shown without moderator approval'
s.cfg_treevite_desc =
  '[EXPERIMENTAL FEATURE] Enable Invite Tree. Nobody can participate without an invite. Invites are managed in waves.'
s.cfg_importance_desc =
  '[EXPERIMENTAL FEATURE] Participants can see the "This comment is important" checkbox'
s.cfg_demographics_desc =
  '[EXPERIMENTAL FEATURE] Participants complete a short entry survey (gender, age, social status, work situation) before voting. Answers are linked to UTM tags and available in reports.'
s.cfg_topics_desc =
  '[EXPERIMENTAL FEATURE] Participants can select priority topics. (Requires advanced reporting).'

// UTM link builder (Distribute tab)
s.utm_builder_heading = 'UTM links for sharing'
s.utm_builder_hint =
  'Build a share link with UTM tags for each channel. Source is required; the rest are optional. Saved links are kept in this browser.'
s.utm_source_label = 'Source (utm_source) *'
s.utm_medium_label = 'Medium (utm_medium)'
s.utm_campaign_label = 'Campaign (utm_campaign)'
s.utm_term_label = 'Term (utm_term)'
s.utm_content_label = 'Content (utm_content)'
s.utm_generated_link = 'Generated link'
s.utm_copy = 'Copy'
s.utm_copied = 'Copied!'
s.utm_save = 'Save to list'
s.utm_saved_heading = 'Saved links'
s.utm_remove = 'Remove'
s.utm_empty = 'No saved links yet.'

// ── InteriorHeader ────────────────────────────────────────────────────────────
s['sign out'] = 'sign out'

// ── Conversations page ────────────────────────────────────────────────────────
s['All Conversations'] = 'All Conversations'
s['My Conversations'] = 'My Conversations'
s['Create new conversation'] = 'Create new conversation'
s['Loading conversations...'] = 'Loading conversations...'
s['Error loading conversations'] = 'Error loading conversations'

// Table headers
s.col_topic = 'Topic'
s.col_participants = 'Participants'
s.col_comments = 'Comments'
s.col_updated = 'Updated'
s.col_created = 'Created'
s.col_owner_email = 'Owner email'
s.col_active = 'Active'

// Mobile labels
s.label_topic = 'Topic: '
s.label_participants = 'Participants: '
s.label_comments = 'Comments: '
s.label_updated = 'Updated: '
s.label_created = 'Created: '
s.label_owner = 'Owner: '
s.label_active = 'Active: '

// Filters
s.filter_owner_email = 'Owner email contains...'
s.filter_all_statuses = 'All statuses'
s.filter_active = 'Active'
s.filter_inactive = 'Inactive'
s.filter_min_comments = 'Min. comments'
s.filter_min_participants = 'Min. participants'
s.filter_updated_days = 'Updated in last N days'
s.filter_created_days = 'Created in last N days'
s.sort_updated = 'Sort: Updated'
s.sort_created = 'Sort: Created'
s.sort_participants = 'Sort: Participants'
s.sort_comments = 'Sort: Comments'
s.sort_desc = 'Descending'
s.sort_asc = 'Ascending'
s.btn_apply = 'Apply'

// ── Conversation card (Conversation.js) ──────────────────────────────────────
s.participants_count = 'participants'
s.embedded_on = 'Embedded on'

// ── Conversation admin nav tabs ───────────────────────────────────────────────
s.nav_all = 'All'
s.nav_configure = 'Configure'
s.nav_distribute = 'Distribute'
s.nav_moderate = 'Moderate'
s.nav_monitor = 'Monitor'
s.nav_reports = 'Reports'
s.nav_invite_tree = 'Invite Tree'
s.nav_invite_codes = 'Invite Codes'
s.nav_participants = 'Participants'
s.nav_import = 'Import'



// ── Monitor / stats tab ──
s.mon_monitor = "Monitor"
s.mon_loading = "Loading..."
s.mon_participants_voted = "participants voted"
s.mon_votes_were_cast = "votes were cast"
s.mon_votes_per_participant_average = "votes per participant on average"
s.mon_commented = "commented"
s.mon_comments_submitted = "comments submitted"
s.mon_utm_sources = "UTM Sources"
s.mon_download_csv = "Download CSV"
s.mon_source = "Source"
s.mon_medium = "Medium"
s.mon_campaign = "Campaign"
s.mon_participants = "Participants"
s.mon_dim_gender = "Gender"
s.mon_dim_age_group = "Age group"
s.mon_dim_social_status = "Social status"
s.mon_dim_work_situation = "Work situation"
s.mon_demographics = "Demographics"
s.mon_voters_over_time = "Voters over time, by time of first vote"
s.mon_commenters_over_time = "Commenters over time, by time of first comment"

// ── Configure & moderation residuals ──
s.cfg2_conversation_is_open = "Conversation Is Open"
s.cfg2_visualization = "Visualization"
s.cfg2_comment_form = "Comment form"
s.cfg2_help_text = "Help text"
s.cfg2_subscribe_prompt = "Prompt participants to subscribe to updates"
s.cfg2_enable_invite_tree = "Enable Invite Tree"
s.cfg2_importance_enabled = "Importance Enabled"
s.cfg2_demographics_survey = "Demographics Survey"
s.cfg2_topics_enabled = "Topics Enabled"
s.cfg2_loading_accepted_comments = "Loading accepted comments..."
s.cfg2_comment_flagged_automod = "Comment flagged by Polis Auto Moderator API. Comment not shown to participants. Accept to override."
s.cfg2_metadata = "metadata"

// ── Reports tab ──
s.rep_showing_moderated_only = "Showing only moderated comments"
s.rep_showing_moderated_unmoderated = "Showing moderated and unmoderated comments"
s.rep_showing_all_comments = "Showing all comments, including those moderated out"
s.rep_minutes_ago = "minutes ago"
s.rep_hours_ago = "hours ago"
s.rep_days_ago = "days ago"
s.rep_loading_reports = "Loading Reports..."
s.rep_reports = "Reports"
s.rep_select_comments_visible = "Select which comments will be visible in this report:"
s.rep_include_all_comments = "Include all comments"
s.rep_include_all_except_rejections = "Include all comments except for moderation rejections"
s.rep_include_accepted_only = "Include only moderator accepted comments"
s.rep_create_report_url = "Create report url"
s.rep_modified = "Modified"
s.rep_report_id = "Report ID"
s.rep_report_urls = "Report URLs"
s.rep_standard_report = "Standard Report"
s.rep_data_export = "Data Export"
s.rep_topic = "Topic"
s.rep_topics_viz = "Topics Viz"
s.rep_topic_stats = "Topic Stats"
s.rep_topic_map_narrative = "Topic Map Narrative"
s.rep_analysis_insights = "Analysis & Insights"
s.rep_delphi_discover_more = "Discover more with Delphi - advanced data analysis and AI"

// ── Topics moderation tab ──
s.top_loading = "Loading..."
s.top_topic_moderation = "Topic Moderation"
s.top_topics_tree = "Topics Tree"
s.top_proximity_map = "Proximity Map"
s.top_statistics = "Statistics"
s.top_moderation_not_enabled = "Topic moderation is not enabled for this conversation."
s.top_see = "See"
s.top_for_more_information = "for more information."
s.top_topic_moderation_statistics = "Topic Moderation Statistics"
s.top_failed_load_statistics = "Failed to load statistics"
s.top_network_error_statistics = "Network error loading statistics"
s.top_loading_statistics = "Loading statistics..."
s.top_error = "Error"
s.top_no_statistics_available = "No statistics available."
s.top_total_topics = "Total Topics"
s.top_pending = "Pending"
s.top_accepted = "Accepted"
s.top_rejected = "Rejected"
s.top_completion_rate = "Completion Rate"
s.top_moderation_progress = "Moderation Progress"
s.top_overall_progress = "Overall Progress"
s.top_complete = "Complete"
s.top_no_topics_generated_yet = "No topics have been generated for this conversation yet."
s.top_run_delphi_to_generate = "Run the Delphi pipeline to generate topics for moderation."
s.top_failed_load_comments = "Failed to load comments"
s.top_network_error_comments = "Network error loading comments"
s.top_meta = "Meta"
s.top_id = "ID"
s.top_cluster = "Cluster"
s.top_layer = "Layer"
s.top_position = "Position"
s.top_loading_comments = "Loading comments..."
s.top_retry = "Retry"
s.top_back_to_topics = "Back to Topics"
s.top_topic = "Topic"
s.top_comments = "comments"
s.top_select_all = "Select All"
s.top_selected = "selected"
s.top_accept_selected = "Accept Selected"
s.top_reject_selected = "Reject Selected"
s.top_no_comments_found = "No comments found for this topic."
s.top_failed_load_topics = "Failed to load topics"
s.top_network_error_topics = "Network error loading topics"
s.top_status = "Status"
s.top_unnamed_topic = "Unnamed Topic"
s.top_no_comments = "No comments"
s.top_accept = "Accept"
s.top_reject = "Reject"
s.top_view_comments = "View Comments"
s.top_model = "Model"
s.top_unknown = "Unknown"
s.top_created = "Created"
s.top_moderated_by = "Moderated by"
s.top_topics_lower = "topics"
s.top_loading_topics = "Loading topics..."
s.top_no_topics_available = "No topics available for this conversation."
s.top_topics_generated_by_delphi = "Topics are generated by the Delphi pipeline. Make sure the pipeline has been run for this conversation."
s.top_view_layer = "View Layer"
s.top_all_layers = "All Layers"
s.top_no_coordinate_data = "No coordinate data available"
s.top_comment = "Comment"
s.top_umap_dimension_1 = "UMAP Dimension 1"
s.top_umap_dimension_2 = "UMAP Dimension 2"
s.top_failed_load_proximity = "Failed to load proximity data"
s.top_network_error_proximity = "Network error loading proximity data"
s.top_loading_proximity = "Loading proximity visualization..."
s.top_proximity_visualization = "Proximity Visualization"
s.top_proximity_description = "This visualization shows comments positioned by semantic similarity using UMAP coordinates. Comments that are closer together are more semantically similar."
s.top_hover_hint = "Hover over points to see comment details. Points are grouped by semantic clusters."
s.top_no_proximity_data = "No proximity data available for this layer."

// ── Distribute / invites / participants ──
s.dist_failed_load_invite_codes = "Failed to load invite codes"
s.dist_status_unused = "Unused"
s.dist_status_used = "Used"
s.dist_status_revoked = "Revoked"
s.dist_status_expired = "Expired"
s.dist_status = "Status"
s.dist_failed_download_csv = "Failed to download CSV"
s.dist_invite_codes_heading = "Invite Codes"
s.dist_invite_tree_not_enabled = "Invite Tree is not enabled. To use this feature, enable Invite Tree in the Conversation Configure options."
s.dist_invite_codes_owner_desc = "These are the invite codes for the owner of this conversation."
s.dist_preparing = "Preparing…"
s.dist_download_csv = "Download CSV"
s.dist_filters = "Filters"
s.dist_wave = "Wave"
s.dist_all_waves = "All waves"
s.dist_all_statuses = "All statuses"
s.dist_clear_filters = "Clear Filters"
s.dist_found = "Found"
s.dist_invite_codes_lc = "invite codes"
s.dist_col_code = "Code"
s.dist_col_used_at = "Used At"
s.dist_na = "N/A"
s.dist_no_invite_codes_found = "No invite codes found. Create waves in the Invite Tree section to generate codes."
s.dist_failed_load_waves = "Failed to load waves"
s.dist_failed_create_wave = "Failed to create wave"
s.dist_invite_tree_heading = "Invite Tree"
s.dist_invite_only_desc = "This conversation is invite only. Participants must enter a valid invite code to vote or comment."
s.dist_waves = "Waves"
s.dist_parent = "parent"
s.dist_owner = "owner"
s.dist_size = "size"
s.dist_no_waves_yet = "No waves yet. Create the initial wave below."
s.dist_create_next_wave = "Create Next Wave"
s.dist_invites_per_user_desc = "Invites per user (granted to each participant in the parent wave)"
s.dist_owner_invites_desc = "Owner invites (additional invites for you to distribute this wave)"
s.dist_parent_wave_desc = "Parent wave (optional override). Default is latest existing wave; use 0 for root."
s.dist_latest_default = "Latest (default)"
s.dist_root_0 = "Root (0)"
s.dist_creating = "Creating…"
s.dist_create_wave = "Create Wave"
s.dist_created_wave = "Created wave"
s.dist_invites_created = "Invites created"
s.dist_embedded_on = "Embedded on:"
s.dist_distribute = "Distribute"
s.dist_share = "Share"
s.dist_embed = "Embed"
s.dist_embed_single_conversation = "This embed code can only be used to embed a single conversation."
s.dist_integrate_entire_site = "I want to integrate pol.is on my entire site."
s.dist_failed_load_xids = "Failed to load XIDs"
s.dist_participant_management = "Participant Management"
s.dist_manage_participants_for = "Manage participants for conversation"
s.dist_xid_required_to_vote = "XID Required to Vote"
s.dist_xid_required_because_allow_list = "Required because XID Allow List is enabled."
s.dist_use_xid_allow_list = "Use XID Allow List"
s.dist_xids_in_use = "XIDs in Use"
s.dist_xids_allowed = "XIDs Allowed"
s.dist_no_xids_found = "No XIDs found for this conversation."
s.dist_download_xid_csv = "DOWNLOAD XID CSV"
s.dist_loading_conversation_uuid = "Loading conversation UUID for XID download..."
s.dist_could_not_load_conversation_uuid = "Could not load conversation UUID for XID download"
s.dist_xid_csv_download = "xid csv download"
s.dist_no_conversation_uuid_available = "No conversation UUID available for XID download"
s.dist_what_is_an_xid = "WHAT IS AN XID? GET UP AND RUNNING WITH PARTICIPANT IDENTITY!"
s.dist_embed_code_loginless_param = "Embed code parameter that allows login-less participation by known users"
s.dist_file_content_not_text = "File content is not text"
s.dist_parsing_failed = "Parsing failed: expected string result"
s.dist_error_reading_file = "Error reading file"
s.dist_enter_at_least_one_xid = "Please enter at least one XID"
s.dist_upload_xids = "Upload XIDs"
s.dist_upload_xids_desc = "Upload a file or paste a list of XIDs to allow. Supports CSV files (with or without headers) and plain text files (one XID per line)."
s.dist_processing_file = "Processing file..."
s.dist_drop_file_here = "Drop file here"
s.dist_click_to_browse = "Click to browse or drag and drop file here"
s.dist_supports_csv_text = "Supports CSV and text files"
s.dist_allowed_xids = "Allowed XIDs"
s.dist_paste_xids_placeholder = "Paste XIDs here, one per line, or upload a file above"
s.dist_replace_all_existing_xids = "Replace all existing XIDs"
s.dist_cancel = "Cancel"



// ── Main nav (MainLayout) ──
s.nav_conversations = "Conversations"
s.nav_integrate = "Integrate"
s.nav_account = "Account"

// ── Moderation & pagination ──
s.mod_moderate = "Moderate"
s.mod_unmoderated = "Unmoderated"
s.mod_accepted = "Accepted"
s.mod_rejected = "Rejected"
s.mod_accept = "accept"
s.mod_reject = "reject"
s.mod_loading_unmoderated = "Loading unmoderated comments..."
s.mod_loading_accepted = "Loading accepted comments..."
s.mod_loading_rejected = "Loading rejected comments..."
s.mod_showing = "Showing"
s.mod_of = "of"
s.mod_items = "items"
s.mod_first = "First"
s.mod_previous = "Previous"
s.mod_next = "Next"
s.mod_last = "Last"
s.mod_page = "Page"

// ── Account / Integrate / import pages ──
s.pg_account = "Account"
s.pg_hi = "Hi"
s.pg_account_profile = "Profile"
s.pg_account_name = "Name"
s.pg_account_email = "Email"
s.pg_account_position = "Position"
s.pg_account_phone = "Phone"
s.pg_account_org = "Organization"
s.pg_account_org_name = "Organization name"
s.pg_account_org_description = "Description"
s.pg_account_org_logo = "Logo"
s.pg_account_org_logo_url = "or paste a URL"
s.pg_account_logo_uploading = "Uploading…"
s.pg_account_logo_too_large = "File too large (max 500 KB)"
s.pg_account_logo_error = "Logo upload error"
s.pg_account_org_contact_email = "Contact email"
s.pg_account_org_contact_phone = "Contact phone"
s.pg_account_save = "Save"
s.pg_account_saving = "Saving…"
s.pg_account_saved = "Saved"
s.pg_account_save_error = "Save error"
s.pg_account_members = "Organization members"
s.pg_account_members_empty = "No members yet"
s.pg_account_invite_email = "Invite by email"
s.pg_account_invite = "Invite"
s.pg_account_inviting = "Sending…"
s.pg_account_invite_sent = "Invitation sent"
s.pg_account_invite_error = "Invitation error"
s.pg_account_invite_bad_email = "Invalid email address"
s.pg_account_pending_invites = "Pending invites"
s.pg_account_invite_accept = "Join the organization"
s.pg_account_invite_accepting = "Joining…"
s.pg_account_invite_accepted = "You have joined the organization"
s.pg_account_invite_accept_error = "Could not accept the invitation"
s.pg_integrate = "Integrate"
s.pg_integrate_intro = "Copy and paste this code into your content management template. Each page (article, post) requires a unique string in the \"PAGE_ID\" field. This should be consistent over time and unique to each of your pages (like the article title)."
s.pg_integrate_li_create = "When this embed code loads on your website, it will either create a new conversation (if one is not already associated with the string passed into PAGE_ID) or load an existing conversation."
s.pg_integrate_li_track = "This embed code will keep track of what conversations belongs on what pages via the data-page_id HTML attribute."
s.pg_integrate_li_replace = "Simply replace \"PAGE_ID\", either manually or in your templates, to create new conversations and load existing ones in the right place."
s.pg_file_too_big = "File is too big! Maximum size is 50MB."
s.pg_import = "Import"
s.pg_import_success = "Your import was successful. You will receive an email once the job is completed."
s.pg_import_desc = "Import external conversation data (comments and votes) from external sources for reporting metrics. This function requires uploading two CSV files, one containing comments, and another containing votes. Comment upload must occur first. After a successful import job, you will recieve an email notifying you that the data is ready."
s.pg_import_comments = "Import Comments"
s.pg_upload_votes_csv_heading = "Upload a CSV of votes. comment_id field MUST match original_id field in comments csv. Size limit 50MB"
s.pg_csv_format = "CSV Format:"
s.pg_vote_value_pattern = "vote_value MUST follow the pattern: 1 = agree, -1 = disagree, 0 = neutral/pass"
s.pg_upload_votes = "Upload Votes"

// ── XID explanation prose ──
s.xid_sometimes_the = "Sometimes, the "
s.xid_of_a = " of a "
s.xid_has_existing_linkage = " has some existing linkage to the identity of their "
s.xid_email_campaign_login_wall = ", i.e., they are sending out an email campaign or people are participating behind a login wall where the conversation is embedded"
s.xid_a_note_using = "A note: using "
s.xid_assumes_that_the = " assumes that the "
s.xid_has_the_token_different_from = " has the token, this is different from "
s.xid_creating_single_use_urls = "creating single use urls"
s.xid_works_in_embedded_case = " works in the embedded case — i.e., the "
s.xid_has_added_the = " has added the "
s.xid_embed_code_label = "embed code"
s.xid_to_page_on_web_property = " to a page on their own web property"
s.xid_once_the = "Once the "
s.xid_embedded_third_party_add_attribute = " has been embedded on a third party webpage, that page can, however it likes, via JavaScript or via templating for instance, add the data attribute "
s.xid_the_value_prefix = "The "
s.xid_value_available_on_record = " value for each participant will be available on the participation record in the "
s.xid_export_label = "export"
s.xid_example = "Example"
s.xid_common_workflow_for_using = "A common workflow for using "
s.xid_involves_table_demographic = " involves a table of demographic data available from a polling provider"
s.xid_sent_email_invited = " are sent an email and invited to participate"
s.xid_then_when_the = "Then, when the "
s.xid_clicks_through_custom_url = " clicks through the email to a custom url, custom JavaScript written by whoever is controlling the third party website on which polis is embedded grabs a token out of the url and adds it to the"
s.xid_usage = "Usage: "
s.xid_or_comma = ", or "
s.xid_or_less_anonymously = ", or less anonymously and not recommended "


// ── Seed comments / XID tables / glossary ──
s.seed_submit = "Submit"
s.seed_success = "Success!"
s.seed_saving = "Saving..."
s.seed_add = "Add"
s.seed_bulk_upload_link = "seed comments or bulk upload as csv"
s.seed_for_participants_to_vote = "for participants to vote on:"
s.seed_upload_csv_heading = "Upload a CSV of seed comments"
s.seed_csv_format = "CSV Format:"
s.seed_original_id_uuid = "original_id MUST be a UUID."
s.xal_upload_xids = "Upload XIDs"
s.xal_preparing = "Preparing…"
s.xal_download_csv = "Download CSV"
s.xal_no_xids = "No XIDs in the allow list for this conversation."
s.xal_failed_load = "Failed to load XID Allow List"
s.xal_failed_download = "Failed to download CSV"
s.xal_failed_upload = "Failed to upload XIDs"
s.xiu_preparing = "Preparing…"
s.xiu_download_csv = "Download CSV"
s.xiu_votes = "Votes"
s.xiu_failed_download = "Failed to download CSV"
s.xidg_owner_nom = "owner"
s.xidg_conversation_gen = "conversation"
s.xidg_conversation_acc = "conversation"
s.xidg_participants_gen = "participants"
s.xidg_participants_nom = "participants"
s.xidg_participant_nom = "participant"

export default s
